import PropTypes from 'prop-types'
import useAuth from '@/hooks/useAuth'
import PermissionRequired from '@/pages/403'
import { hasRole } from '@/utils/hasRole'

const RoleGuard = (props) => {
    const { children, roles } = props
    const { user } = useAuth()

    const canView = hasRole(user, roles)

    if (!canView) {
        return <PermissionRequired />
    }

    return <>{children}</>
}

RoleGuard.propTypes = {
    children: PropTypes.node,
    roles: PropTypes.array
}

export default RoleGuard
